import Login from "../components/Login";

export default function Home() {
  return (
    <div className="flex flex-col items-center 2xl:pt-[7%] min-h-screen p-5 bg-white">
      <Login />
    </div>
  );
}
